import type { JSX } from 'react'

export type TextAlignment = 'left' | 'center' | 'right'
export interface StyledAsProps {
  as?: React.ElementType | keyof JSX.IntrinsicElements
  $color?: string
  $size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'error-title'
  $weight?: '400' | '500' | '600' | '700' | '800' | '900'
  $textAlign?: TextAlignment
  $textTransform?: 'lowercase' | 'uppercase' | 'capitalize'
}

export const BREAKPOINTS = {
  MD: '(min-width: 768px)',
}
